// Utility functions for time-based alerts

/**
 * Format days into human-readable interval
 * @param {number} days - Number of days
 * @returns {string} Formatted interval string
 */
export const formatInterval = (days) => {
  if (!days) return '';
  if (days % 365 === 0) return `${days / 365} year${days / 365 > 1 ? 's' : ''}`;
  if (days % 30 === 0) return `${days / 30} month${days / 30 > 1 ? 's' : ''}`;
  if (days % 7 === 0) return `${days / 7} week${days / 7 > 1 ? 's' : ''}`;
  return `${days} day${days > 1 ? 's' : ''}`;
};

/**
 * Format date string for display
 * @param {string} dateStr - Date string to format
 * @returns {string} Formatted date
 */
export const formatNextDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString();
};

/**
 * Calculate the next alert date
 * @param {Date} startDate - Starting date
 * @param {number} everyXDays - Interval in days
 * @param {boolean} recurring - Whether the alert is recurring
 * @returns {Date|null} Next alert date
 */
export const calculateNextDate = (startDate, everyXDays, recurring) => {
  if (!startDate || !everyXDays) return null;

  const start = new Date(startDate);
  const now = new Date();

  if (recurring) {
    // For recurring: next occurrence after today
    const daysSinceStart = Math.floor((now - start) / (1000 * 60 * 60 * 24));
    const cyclesPassed = Math.floor(daysSinceStart / everyXDays);
    const nextDate = new Date(start);
    nextDate.setDate(start.getDate() + ((cyclesPassed + 1) * everyXDays));
    return nextDate;
  } else {
    // For one-time: startDate + everyXDays
    const nextDate = new Date(start);
    nextDate.setDate(start.getDate() + everyXDays);
    return nextDate;
  }
};